import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import { ReporteCuentasPorPagarService } from '../../services/reportes/reporte-cuentas-por-pagar.service';
import { ObrasService } from '../../services/obras.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorPagarService } from '../../services/cuentas-por-pagar.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { AutenticacionService, ModulosARK, TipoPermiso } from '../../services/autenticacion.service';
import { ModalEditarCXPComponent } from './modal-editar-cxp/modal-editar-cxp.component';
import { ModalEliminarCXPComponent } from './modal-eliminar-cxp/modal-eliminar-cxp.component';
import { ReportesService } from './../../services/reportes.service';
import { MovimientosObraService } from '../../services/movimientos-obra.service';
import { ProveedoresService } from '../../services/proveedores.service';
import { ConceptosService } from '../../services/conceptos.service';
import { UsuariosService } from '../../services/usuarios.service';

@Component({
  selector: 'app-reporte-cxp',
  templateUrl: './reporte-cxp.component.html',
  styleUrls: ['./reporte-cxp.component.scss']
})
export class ReporteCXPComponent implements OnInit {
    @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
    @ViewChild('modalAutorizar') private content: TemplateRef<any>;
    @ViewChild('modalPreautorizar') private modalPreautorizar: TemplateRef<any>;
    @ViewChild(ModalEditarCXPComponent) private modalEditarCXP: ModalEditarCXPComponent;
    @ViewChild('modalEliminarCP') private modalEliminarCXP: ModalEliminarCXPComponent;

    public reporteInmuebles: any[] = [];
    public totalesArray: any [] = [];

    //Selector reporte
    public reportes_lista: any[];
    public reporte_actual: any = {};
    public cuentasPorPagar: any [] = [];
    
    //filters
    public fechaVencimientoPago: any;
    public obraSelected: any = {};
    public estatusSelected: any;
    public showCalendars:boolean = false;
    public fechaInicio: any = null;
    public fechaFin: any = null;
    public proveedorSelected: any = {};
    public conceptoSelected: any = {};
    public importeMin: number = null;
    public importeMax: number = null;
    public creadorGastoSelected: any = {};
    
    //helpers
    public inmuebles: any [] = [];
    public proveedores: any [] = [];
    public conceptos: any [] = [];
    public usuarios: any [] = [];
    public loading: boolean = false;
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;
    public loading_conceptos: boolean = false;
    public loading_usuarios: boolean = false;
    public modal: any = null;
    public cuentaSeleccionada: any = null;
    public permitirAutorizarCPX: boolean = false;
    public permitirEditarCXP: boolean = false;
    public adminCXP:boolean = false;
    public user = {};
    public canPreautorizarPago = false;
    public estatusList = [];
    public settingCalendars: boolean = false;
    public exportingCSV: boolean = false;

    constructor(private router: Router,
        private obrasService: ObrasService,
        private reporteService: ReporteCuentasPorPagarService,
        private modalService: NgbModal,
        private cxpService: CuentasPorPagarService,
        private helperService: HelpersService,
        private authService: AutenticacionService,
        private reportesService: ReportesService,
        private movimientosObraService: MovimientosObraService,
        private proveedoresService: ProveedoresService,
        private conceptosService: ConceptosService,
        private usuariosService: UsuariosService) {
    }

    ngOnInit() {
        this.getUser();
    }

    private setupComponent(){
        this.loadCuentasPorPagar();
        this.loadObras();
        this.loadProveedores();
        this.loadConceptos();
        this.loadUsuarios();
        this.permitirAutorizarCPX = this.authService.tienenPermisos(ModulosARK.AutorizarCuentasPorPagar, TipoPermiso.Escritura);
        this.permitirEditarCXP = this.authService.tienenPermisos(ModulosARK.ReporteCuentasPorPagar, TipoPermiso.Escritura);
        this.adminCXP = this.authService.tienenPermisos(ModulosARK.ActualizarEliminarCuentasPorPagar, TipoPermiso.Escritura);
        this.canPreautorizarPago = this.authService.tienenPermisos(ModulosARK.PreautorizarCuentasPorPagar, TipoPermiso.Escritura);
        console.log("this.canPreautorizarPago: ",this.canPreautorizarPago);
        console.log("this.adminCXP: ",this.adminCXP);
        console.log("permitirEditarCXP: ",this.permitirEditarCXP);
        this.loadCuentasPorPagarEstatus();
    }

    // MAIN SECTIONS FUNCTIONS     
    writePermission() {
        return true;
    }

    canExport() {
        //return true;
        //console.log("canExport: ",this.movimientosObraService.canExport());
        return this.movimientosObraService.canExport();
    }
    
    exportCSV() {
        this.exportingCSV = true;
        //console.log("this.obra.idObras: ",this.obra.idObras);ç
        const filters = this.getFiltes();
        this.cxpService.exportCSV(filters)
          .subscribe((response) => {
            this.exportingCSV = false;
          }, (error) => {
            // se resuelven los errores 403 y 500
            this.helperService.httpGlobalError(error);
        });
    }

    public estatusChange(event){
        console.log("estatusChange!",event);
        this.estatusSelected=event.key;
        if(this.estatusSelected == "PAGADO"){
            this.showCalendars = true;
            this.getFechaActual();
        }else{
            this.showCalendars = false;
            this.fechaInicio = null;
            this.fechaFin = null;
            this.loadCuentasPorPagar();
        }
    }

    public getFechaActual() {
        this.settingCalendars = true;
        this.reportesService.getFechaActual()
            .subscribe((response) => {
                const content = response.json().content;
                console.log("getFechaActual: ",content);
                this.fechaInicio = content.fechaInicio;
                this.fechaFin = content.fechaFinal;
                this.settingCalendars = false;
                this.loadCuentasPorPagar();
            }, (error) => {
              // se revisan errores 403 - 500
              this.helperService.httpGlobalError(error);
              if (error == 400) {
                console.log('getFechasActual - error 400 ' , error);
              }
            });
    }

    public loadCuentasPorPagar(){
        console.log("this.settingCalendars: ",this.settingCalendars);
        //Se requiere definir la fecha de vencimiento para consultar el reporte
        if(!this.fechaVencimientoPago || this.settingCalendars==true){
            return;
        }
        this.loading = true;
        let filters = this.getFiltes();

        this.reporteService.getCuentasPorPagar(filters)
        .subscribe(response => {
            let content = response.json().content;
            console.log("content: ",content);
            //this.cuentasPorPagar = content.items;
            //this.totalesArray = content.totales;
            this.reporteInmuebles = content.obras;
            console.log('#content.obras', content.obras);
            this.totalesArray = content.totales;
            this.loading = false;
        },error=>{
            console.log("Error loading cuentas por pagar: ", error);
            this.reporteInmuebles = [];
            this.totalesArray = [];
            this.loading = false;
            
            // Provide user-friendly error handling
            if (error.status === 404) {
                console.log("Cuentas por pagar endpoint not found");
            } else if (error.status === 500) {
                console.log("Server error when loading cuentas por pagar");
            } else {
                console.log("Unexpected error when loading cuentas por pagar: ", error.status);
            }
        });
    }

    private loadObras(){
        this.loading_obras = true;
        this.obrasService.getObratoSelect('')
        .subscribe((response) => {
            this.inmuebles = response.json().content;
            console.log("this.inmuebles: ",this.inmuebles);
            this.loading_obras = false;
        },error=>{
            console.log("Error loading obras: ", error);
            this.inmuebles = [];
            this.loading_obras = false;
        });
    }

    private loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe((response) => {
            this.proveedores = response.json().content.proveedores || response.json().content;
            console.log("this.proveedores: ",this.proveedores);
            this.loading_proveedores = false;
        },error=>{
            console.log("Error loading proveedores: ",error);
            this.proveedores = [];
            this.loading_proveedores = false;
        });
    }

    private loadConceptos(){
        this.loading_conceptos = true;
        this.conceptosService.getConceptostoSelect()
        .subscribe((response) => {
            this.conceptos = response.json().content;
            console.log("this.conceptos: ",this.conceptos);
            this.loading_conceptos = false;
        },error=>{
            console.log("Error loading conceptos: ",error);
            this.conceptos = [];
            this.loading_conceptos = false;
        });
    }

    private loadUsuarios(){
        this.loading_usuarios = true;
        this.usuariosService.getUsuariosDepositos()
        .subscribe((response) => {
            this.usuarios = response.json().content.data || response.json().content;
            console.log("this.usuarios: ",this.usuarios);
            this.loading_usuarios = false;
        },error=>{
            console.log("Error loading usuarios: ",error);
            this.usuarios = [];
            this.loading_usuarios = false;
        });
    }

    // private loadUsuarios(){
    //     this.loading_usuarios = true;
    //     // Cambiar de getUsuarios() a getCreadoresGastos()
    //     this.usuariosService.getCreadoresGastos()
    //     .subscribe((response) => {
    //         this.usuarios = response.json().content.data || response.json().content;
    //         console.log("Creadores de gastos: ", this.usuarios);
    //         this.loading_usuarios = false;
    //     },error=>{
    //         console.log("Error loading creadores de gastos: ", error);
    //         this.usuarios = [];
    //         this.loading_usuarios = false;
    //     });
    // }

    //Selector de reporte
    public changeReporte(reporte) {
        if (reporte.id && reporte.id != this.reporte_actual.id) {
          this.router.navigate([reporte.ruta]);
        }
    }

    public return() {
        this.router.navigate(['/catalogo-reportes']);
    }

    public print() {
        setTimeout(() => {
          window.print();
        }, 1200);
    }
    
    /**
     * Modal functions
     */
    public showModalAutorizacion(cuentaSeleccionada){
        this.cuentaSeleccionada = cuentaSeleccionada;
        this.modal = this.modalService.open(this.content, { });
    }

    public showModalPreautorizacion(cuentaSeleccionada){
        this.cuentaSeleccionada = cuentaSeleccionada;
        this.modal = this.modalService.open(this.modalPreautorizar, { });
    }

    public closeModal() {
        this.modal.close();
    }

    public autorizarCuenta(){

        if(!this.cuentaSeleccionada){
            return;
        }

        this.cxpService.autorizarCuentaPorPagar(this.cuentaSeleccionada.id_cuenta_por_pagar).subscribe(
            (response)=>
            {
                const result = response.json().content;
                this.cuentaSeleccionada.estatus = 'AUTORIZADO';
                this.closeModal();
                this.helperService.notification('Cuenta autorizada', 'Se ha autorizado exitosamente la cuenta por pagar', 'success');

            }, error =>
            {
              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);
              if(error.status == 400) {
                alert("ERROR: "+JSON.stringify(error));
              }
            }
        );
    }

    public preautorizarCuenta(){

        if(!this.cuentaSeleccionada){
            return;
        }
        this.cxpService.preautorizarCuentaPorPagar(this.cuentaSeleccionada.id_cuenta_por_pagar).subscribe(
            (response)=>
            {
                const result = response.json().content;
                this.cuentaSeleccionada.estatus = 'PRE-AUTORIZADO';
                this.closeModal();
                this.helperService.notification('Cuenta preautorizada', 'Se ha preautorizado exitosamente la cuenta por pagar', 'success');

            }, error =>
            {
              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);
              if(error.status == 400) {
                alert("ERROR: "+JSON.stringify(error));
              }
            }
        );
    }

    public mostrarModalEditarCXP(cuenta){
        this.modalEditarCXP.openModal(cuenta);
    }

    public mostrarModalEliminarCXP(cuenta){
        this.modalEliminarCXP.openModal(cuenta);
    }

    public loadCuentasPorPagarEstatus(){
        this.reporteService.getCuentasPorPagarEstatus()
        .subscribe(response => {
            this.estatusList = response.json().content;
            console.log('this.estatusList content', this.estatusList);
        },error=>{
            console.log("Error loading estatus list: ", error);
            this.estatusList = [];
        });
    }

    /**
     * Utilities
     */

    private getFiltes(){
        //Solo se muestran las cuentas por pagar que tienen los estatus PENDIENTE|AUTORIZADO|PARCIALMENTE_PAGADO|PRE-AUTORIZADO
        let filters = {
            fechaInicio: this.fechaInicio ? this.fechaInicio : null,
            fechaFin: this.fechaFin ? this.fechaFin : null,
            estatus: this.estatusSelected ? this.estatusSelected : 'PENDIENTE|AUTORIZADO|PARCIALMENTE_PAGADO|PRE-AUTORIZADO',
            fecha_pago_limite: this.fechaVencimientoPago,
            id_obra: (this.obraSelected && this.obraSelected.idObras)
                ? this.obraSelected.idObras : null,
            id_proveedor: (this.proveedorSelected && this.proveedorSelected.idProveedores)
                ? this.proveedorSelected.idProveedores : null,
            id_concepto: (this.conceptoSelected && this.conceptoSelected.idConceptos)
                ? this.conceptoSelected.idConceptos : null,
            importe_min: this.importeMin,
            importe_max: this.importeMax,
            id_creador_gasto: (this.creadorGastoSelected && this.creadorGastoSelected.id)
                ? this.creadorGastoSelected.id : null
        }

        return filters;
    }

    public getUser(){
        this.authService.getUser().subscribe((response) => {
            console.log("response: ",response);
            const content = response.json().content;
            this.user = content["user"];
            console.log("this.user: ",this.user);
            this.setupComponent();
        }, (error) => {
            // se revisan errores 403 - 500
            this.helperService.httpGlobalError(error);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/reporte-cxp/reporte-cxp.component.ts